import React, { forwardRef } from "react";

import { DisplayHoursProps } from "./types";
import { formatHours, formatNumber } from "../../utils";
import { parseValueToNumber } from "../../utils/currencyUtils";
import { Tooltip } from "../Tooltip";
import { Typography } from "../Typography/Typography";

export const DisplayHours = forwardRef<HTMLSpanElement, DisplayHoursProps>(
  (
    {
      value,
      variant = "Body 2",
      thousandSeparator = ",",
      decimalSeparator = ".",
      trimZeroMinutes = false,
      trimDecimals = true,
      decimalSpaces = 2,
      format = "long",
      disableTooltip = false,
      className,
      withLeadingZero,
      as = "span",
      ...rest
    },
    ref
  ) => {
    const numberValue = parseValueToNumber(
      value,
      thousandSeparator,
      decimalSeparator
    );

    const shouldDisplayShort = format === "short" && numberValue >= 1000;

    const longValue = formatHours(
      numberValue,
      withLeadingZero,
      trimZeroMinutes,
      "long"
    );
    const shortValue = formatNumber(
      numberValue,
      thousandSeparator,
      decimalSeparator,
      trimDecimals,
      decimalSpaces,
      "short"
    );

    if (shouldDisplayShort) {
      return (
        <Tooltip title={formatHours(numberValue)} disable={disableTooltip}>
          <Typography
            as={as}
            variant={variant}
            className={className}
            ref={ref}
            {...rest}
          >
            {shortValue}
          </Typography>
        </Tooltip>
      );
    }

    return (
      <Typography
        as={as}
        variant={variant}
        className={className}
        ref={ref}
        {...rest}
      >
        {longValue}
      </Typography>
    );
  }
);

DisplayHours.displayName = "DisplayHours";
